import { Route, Redirect } from "react-router-dom";
import { useState } from "react";
import Header from "../Common/Header/";
import { isLoggedIn } from "../../services/login/loginService";

function PrivateRoute({ component: Component, ...rest }) {
  const [auth, setAuth] = useState({
    isLogin: isLoggedIn(),
    isTncAccepted: JSON.parse(localStorage.getItem("tncAccepted")),
  });

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!auth.isLogin) {
          // not logged in so redirect to login page with the return url
          return (
            <Redirect
              to={{
                pathname: `/login`,
                state: { from: props.location },
              }}
            />
          );
        } else if (
          auth.isLogin &&
          (!auth.isTncAccepted ||
            auth.isTncAccepted === undefined ||
            auth.isTncAccepted === null)
        ) {
          return (
            <Redirect
              to={{
                pathname: `/terms-conditions`,
                state: { from: props.location },
              }}
            />
          );
        } else {
          return <Header>{<Component {...props} />}</Header>;
        }
      }}
    />
  );
}

export default PrivateRoute;
